import { Order } from "../Order";
import { HistoryFilterRequest } from "./HistoryFilterRequest";

export class HistoryOrdersList {

    constructor(
        public filters: HistoryFilterRequest,
        public orders: Order[]
    ) {}
}